<!--Da documentazione siteimprove accessibility checker-->
<!--
  Ensure all perceivable text is included in an ARIA landmark.
  The <nav> element automatically communicates that a section has a role of navigation.

  Esempio con <nav>:
  <nav id="nav" aria-label="Main menu">
    <ul>
      <li><a href="page1.html">Home</a></li>
      <li><a href="page2.html">Shop</a></li>
      <li><a href="page3.html">Blog</a></li>
    </ul>
  </nav>

  Esempio con <div>:
  <div role="region" aria-label="Weather"> ...</div>
-->
<div class="test">
  <p>{{ 'test.ui.testInterceptors' | transloco }}</p>

  <button (click)="loadSuccess()">GET 200</button>
  <button (click)="loadForbidden()">GET 403</button>
  <button (click)="loadNotFound()">GET 404</button>

  <hr>

  <div role="region" [attr.aria-label]="'test.ui.demoComponenti' | transloco">
    <h2>{{ 'test.ui.demoComponenti' | transloco }}</h2> <!--Per header e paragrafi non serve l'accessibilità, è già gestita in automatico-->

    <h3>{{ 'test.ui.autocomplete' | transloco }}</h3>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>{{ 'test.ui.animale' | transloco }}</mat-label> <!--mat-label gestisce da solo aria-label, in questo caso non serve inserire altro-->
      <input #animalinput
        type="text"
      [placeholder]="'test.ui.selezionaUnAnimale' | transloco"
        matInput
      [matAutocomplete]="auto"
        (input)="filter()"
        (focus)="filter()"> <!--Per l'input anche, viene gestito tutto in automatico-->

      <button mat-icon-button matSuffix [attr.aria-label]="'test.ui.apriSelezioneAnimale' | transloco"> <!--Trattandosi di una semplice icona, specificare tramite aria-label il suo utilizzo-->
        <mat-icon>pets</mat-icon>
      </button>

      <mat-autocomplete #auto="matAutocomplete" requireSelection [displayWith]="displayFn">
        @for (option of filteredAnimalOptions; track option) {
          <mat-option [value]="option" aria-label="{{option.name}}">{{option.name}}</mat-option>
          <!--In questo caso non abbiamo una mat-label,
          quindi dobbiamo dichiarare la label di ogni opzione aria-label="{{option.name}}"-->
        }
      </mat-autocomplete>
    </mat-form-field>

    <hr>

    <h3>Badge</h3>

    <button
        mat-icon-button
        [attr.aria-label]="'test.ui.notifiche' | transloco"
        [matBadge]="notifications"
        [matBadgeHidden]="!notifications"
        [matBadgeDescription]="('test.ui.haiXNuoveNotifiche' | transloco)"
        matBadgePosition="above after"
        matBadgeColor="warn"
      >
        <!-- <i class="fa-regular fa-bell"></i> -->
        <mat-icon>notifications</mat-icon>
    </button>

    <button
        mat-icon-button
        [attr.aria-label]="'test.ui.notifiche' | transloco"
        [matBadge]="messages"
        [matBadgeHidden]="!messages"
        [matBadgeDescription]="('test.ui.haiXNuoveNotifiche' | transloco)"
        matBadgePosition="above after"
        matBadgeColor="warn"
      >
        <!-- <i class="fa-regular fa-bell"></i> -->
        <mat-icon>mail</mat-icon>
    </button>

    <button [attr.aria-label]="'test.ui.profilo' | transloco" class="profile-button">
        <img src="assets/user.jpg" [alt]="'test.ui.profilo' | transloco" class="profile-image"/>
    </button>

    <hr>

    <h3>{{ 'test.ui.buttons' | transloco }}</h3>

    <!-- Bottone testuale, l'accessibilità è già implementata di default da material-->
    <button matButton>{{ 'test.ui.text' | transloco }}</button>
    <button matButton disabled="true">{{ 'test.ui.textDisabled' | transloco }}</button>

    <br>

    <!-- Bottone con sola icona, è buona norma aggiungere un aria label a descrivere la funzionalità -->
    <button mat-icon-button [attr.aria-label]="'test.ui.impostazioni' | transloco">
      <mat-icon>settings</mat-icon>
    </button>

    <br>

    <!--Button filled-->
    <button matButton="filled">
      <span>{{ 'test.ui.filled' | transloco }}</span>
    </button>
    <button matButton="filled" disabled="true">
      <span>{{ 'test.ui.filledDisabled' | transloco }}</span>
    </button>

    <br>

    <!--Button outlined-->
    <button matButton="outlined">
      <span>{{ 'test.ui.outlined' | transloco }}</span>
    </button>

    <button matButton="outlined" disabled="true">
      <span>{{ 'test.ui.outlinedDisabled' | transloco }}</span>
    </button>


    <hr>

    <h3>{{ 'test.ui.buttonsToggle' | transloco }}</h3>

    <mat-button-toggle-group name="fontStyle" [attr.aria-label]="'test.ui.fontStyle' | transloco">
      <mat-button-toggle value="bold">{{ 'test.ui.bold' | transloco }}</mat-button-toggle>
      <mat-button-toggle value="italic">{{ 'test.ui.italic' | transloco }}</mat-button-toggle>
      <mat-button-toggle value="underline">{{ 'test.ui.underline' | transloco }}</mat-button-toggle>
    </mat-button-toggle-group>

    <!--Come per i casi precedenti, se non sono presenti label aggiungere aria-label o aria-describedby-->
    <!-- es.caso in cui c'è solo una icon senza testo -->
    <hr>

    <h3>{{ 'test.ui.cards' | transloco }}</h3>
    <!--
      Per le card, come scritto nella documentazione, ci sono molteplici opzioni per gestirla.
      Il tutto dipende dall'utilizzo dello stesso mat-card e degli elementi al suo interno,
      i quali seguono le logiche dei singoli componenti angular (es. alt per la descrizione dell'immagine)
      Per maggiori informazioni consultare documentazione:
      https://material.angular.dev/components/card/overview#accessibility
    -->

    <mat-card class="example-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title-group>
          <mat-card-title>Shiba Inu</mat-card-title>
          <mat-card-subtitle>{{ 'test.ui.small' | transloco }}</mat-card-subtitle>
          <img mat-card-sm-image src="https://material.angular.dev/assets/img/examples/shiba2.jpg" [alt]="'test.ui.photoOfAShibaInu' | transloco">
        </mat-card-title-group>
      </mat-card-header>
      <mat-card-content>
        {{ 'test.ui.theShibaInuIsTheSmallestOfTheSixOriginalAndDistinctSpitzBreedsOfDogFromJapanASmallAgileDogThatCopesV' | transloco }}
      </mat-card-content>
    </mat-card>

    <hr>

    <h3>{{ 'test.ui.checkbox' | transloco }}</h3>
    <section class="example-section">
      <mat-checkbox class="example-margin">{{ 'test.ui.checkMe' | transloco }}</mat-checkbox>
      <!--Acessibilità gia integrata, come negli altri casi da implementare solo se manca il testo-->
      <mat-checkbox class="example-margin" [disabled]="true">{{ 'test.ui.checkboxDisabledTrue' | transloco }}</mat-checkbox>
      <mat-checkbox class="example-margin" [disabled]="false">{{ 'test.ui.checkboxDisabledFalse' | transloco }}</mat-checkbox>
      <br>
      <span>{{ 'test.ui.checkboxSenzaTestoPerTestAccessibilita' | transloco }}</span>
      <mat-checkbox [attr.aria-label]="'test.ui.esempioDiCheckboxSenzaTesto' | transloco"></mat-checkbox>
      <br>
      <mat-checkbox class="checkbox-error">{{ 'test.ui.testError' | transloco }}</mat-checkbox>
      <mat-checkbox class="checkbox-error" [disabled]="true">{{ 'test.ui.testErrorDisabled' | transloco }}</mat-checkbox>
    </section>

    <hr>

    <h3>{{ 'test.ui.chips' | transloco }}</h3>

    <h4>{{ 'test.ui.filter' | transloco }}</h4>

    <mat-chip-set [attr.aria-label]="'test.ui.fishSelection' | transloco">
        <mat-chip-option selected="true">{{ 'test.ui.oneFish' | transloco }}</mat-chip-option>
        <mat-chip-option>{{ 'test.ui.twoFish' | transloco }}</mat-chip-option>
        <mat-chip-option>{{ 'test.ui.threeFish' | transloco }}</mat-chip-option>
        <mat-chip-option disabled>{{ 'test.ui.fourFish' | transloco }}</mat-chip-option>

      <!--

      ESEMPIO DI UTILIZZO

      <mat-chip-option
              (selectionChange)="onTipoTaskSelect($event, tipo.id)"
              [selected]="checkTipoTaskSelected(tipo.id)">
              {{ tipo.name }}
          </mat-chip-option>

       -->
    </mat-chip-set>

    <h4>{{ 'test.ui.priority' | transloco }}</h4>

    <ui-priority-status class="storico-priority" priority="Low"></ui-priority-status>
    <ui-priority-status class="storico-priority" priority="Medium"></ui-priority-status>
    <ui-priority-status class="storico-priority" priority="High"></ui-priority-status>
    <ui-priority-status class="storico-priority" priority="Undefined"></ui-priority-status>

    <hr>

    <h3>{{ 'test.ui.datePicker' | transloco }}</h3>

    <!--
    Anche qua, amterial implementa da sè l'accessibilità.
    Salvo casi particolari si può lasciare il componente così com'è
    -->

    <mat-form-field>
      <mat-label>{{ 'test.ui.chooseADate' | transloco }}</mat-label>
      <input matInput [matDatepicker]="picker">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <hr>

    <h3>{{ 'test.ui.dialog' | transloco }}</h3>
    <!--
    Trattandosi di un elemento composto da altri componenti, come per le card, implementare singolarmente
    l'accessibilità dove serve
    -->

    <!-- Bottone per aprire il dialog -->
    <button mat-button (click)="openDialog()">{{ 'test.ui.openDialog' | transloco }}</button>

    <!-- Dialog -->
    <ng-template #dialogTemplate>
      <h2 mat-dialog-title id="dialog-title">{{ 'test.ui.dialogWithElements' | transloco }}</h2>
      <mat-dialog-content id="dialog-content">{{ 'test.ui.thisDialogShowcasesTheTitleCloseContentAndActionsElements' | transloco }}</mat-dialog-content>
      <mat-dialog-actions>
        <button matButton mat-dialog-close>{{ 'test.ui.close' | transloco }}</button>
      </mat-dialog-actions>
    </ng-template>

    <hr>

    <h3>{{ 'test.ui.icons' | transloco }}</h3>
    <!--Di default material imposta aria-hidden a true, ma in base alla casistica potremmo voler modificare-->

    <!--Icone decorative: Non serve dover descrivere l'icona-->
    <p><mat-icon>star</mat-icon> {{ 'test.ui.preferiti' | transloco }}<p>

    <!--Icone Interattive: Fanno parte ad esempio di un pulsante, non serve descriverla se non il bottone vero e proprio-->
    <button mat-icon-button [attr.aria-label]="'test.ui.apriMenuDiNavigazione' | transloco">
      <mat-icon>menu</mat-icon>
    </button>
    <br>

    <!--Icona Informativa: La usiamo ad esempio per indicare lo stato di un processo, quindi ha senso voler descrivere l'icona-->
    <p><mat-icon aria-hidden="false" [attr.aria-label]="'test.ui.error' | transloco" fontIcon="error"></mat-icon>{{ 'test.ui.error' | transloco }}</p>

    <hr>

    <h3>{{ 'test.ui.inputTextarea' | transloco }}</h3>

    <!--Esempio di campo input semplice-->
    <form class="example-form">
      <p>
          <mat-form-field appearance="fill">
              <mat-label>{{ 'test.ui.fillFormField' | transloco }}</mat-label>
              <input matInput [placeholder]="'test.ui.placeholder' | transloco" [formControl]="debugField">
          <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
          <mat-hint>{{ 'test.ui.hint' | transloco }}</mat-hint>

          <mat-error *ngIf="debugField.hasError('errorDebug')">
              {{ 'test.ui.errore' | transloco }}
            </mat-error>
          </mat-form-field>
        </p>

      <p>
          <mat-form-field appearance="fill">
              <mat-label>{{ 'test.ui.fillFormField' | transloco }}</mat-label>
          <mat-icon matPrefix>person</mat-icon>
              <input matInput [placeholder]="'test.ui.placeholder' | transloco">
          <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
          <mat-hint>{{ 'test.ui.hint' | transloco }}</mat-hint>
          </mat-form-field>
        </p>

      <p>
          <mat-form-field appearance="fill">
              <mat-label>{{ 'test.ui.fillFormField' | transloco }}</mat-label>
              <input matInput [placeholder]="'test.ui.placeholder' | transloco">
          <mat-hint>{{ 'test.ui.hint' | transloco }}</mat-hint>
          </mat-form-field>
        </p>

      <p>
          <mat-form-field appearance="fill">
              <mat-label>{{ 'test.ui.fillFormField' | transloco }}</mat-label>
          <mat-icon matPrefix>person</mat-icon>
              <input matInput [placeholder]="'test.ui.placeholder' | transloco">
          <mat-hint>{{ 'test.ui.hint' | transloco }}</mat-hint>
          </mat-form-field>
        </p>

      <p>
          <mat-form-field appearance="outline">
              <mat-label>{{ 'test.ui.fillFormField' | transloco }}</mat-label>
              <input matInput [placeholder]="'test.ui.placeholder' | transloco" [formControl]="debugField">
          <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
          <mat-hint>{{ 'test.ui.hint' | transloco }}</mat-hint>

          <mat-error *ngIf="debugField.hasError('errorDebug')">
              {{ 'test.ui.errore' | transloco }}
            </mat-error>
          </mat-form-field>
        </p>

      <p>
          <mat-form-field appearance="outline">
              <mat-label>{{ 'test.ui.fillFormField' | transloco }}</mat-label>
          <mat-icon matPrefix>person</mat-icon>
              <input matInput [placeholder]="'test.ui.placeholder' | transloco">
          <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
          <mat-hint>{{ 'test.ui.hint' | transloco }}</mat-hint>
          </mat-form-field>
        </p>

      <p>
          <mat-form-field appearance="outline">
              <mat-label>{{ 'test.ui.fillFormField' | transloco }}</mat-label>
              <input matInput [placeholder]="'test.ui.placeholder' | transloco">
          <mat-hint>{{ 'test.ui.hint' | transloco }}</mat-hint>
          </mat-form-field>
        </p>

      <p>
          <mat-form-field appearance="outline">
              <mat-label>{{ 'test.ui.fillFormField' | transloco }}</mat-label>
          <mat-icon matPrefix>person</mat-icon>
              <input matInput [placeholder]="'test.ui.placeholder' | transloco">
          <mat-hint>{{ 'test.ui.hint' | transloco }}</mat-hint>
          </mat-form-field>
        </p>

      <p>
        <mat-form-field appearance="outline" class="searchbar">
          <mat-icon matPrefix>menu</mat-icon>
            <input matInput [placeholder]="'test.ui.ricerca' | transloco" [formControl]="debugField">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </p>

      <mat-form-field class="example-full-width">
        <mat-label>{{ 'test.ui.leaveAComment' | transloco }}</mat-label>
        <textarea matInput [placeholder]="'test.ui.exItMakesMeFeel' | transloco"></textarea>
      </mat-form-field>
    </form>

    <mat-form-field appearance="outline" >
      <mat-label>{{ 'test.ui.outline' | transloco }}</mat-label>
      <input matInput type="text" value="Text" disabled="false"/>
    </mat-form-field>

    <!--Esempio avanzato per form con required(preso dalla demo del form qua sotto)-->

    <!-- <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" id="email" formControlName="email" placeholder="esempio@gmail.com" aria-required="true" aria-describedby="email-errors">
    </mat-form-field>
    @if (userProfileForm.get('email')?.invalid && userProfileForm.get('email')?.touched) {
      <div id="email-errors">
        @if (userProfileForm.get('email')?.errors?.['required']) {
          <div role="alert" aria-live="assertive">
            <span style="color: red">Email è richiesta.</span>
          </div>
        }
        @if (userProfileForm.get('email')?.errors?.['email']) {
          <div role="alert" aria-live="assertive">
            <span style="color: red">Formato email non valido.</span>
          </div>
        }
      </div>
    } -->

    <hr>

    <h3>{{ 'test.ui.paginator' | transloco }}</h3>

    <!--Settare l'aria label specificando che si tratta di un componente per "selezionare" la pagina-->
    <mat-paginator [length]="100"
                  [pageSize]="10"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                  [attr.aria-label]="'test.ui.selectPage' | transloco">
    </mat-paginator>

    <hr>

    <h3>{{ 'test.ui.radioButtons' | transloco }}</h3>

    <mat-radio-group [attr.aria-label]="'test.ui.selectAnOption' | transloco" value="1">
      <mat-radio-button value="1">{{ 'test.ui.option1' | transloco }}</mat-radio-button> <!--Per le options, l'aria label è già fornita da material come se fosse un bottone normale-->
      <mat-radio-button value="2">{{ 'test.ui.option2' | transloco }}</mat-radio-button>
    </mat-radio-group>

    <br>

    <mat-radio-group [attr.aria-label]="'test.ui.selectAnOption' | transloco" value="1" disabled>
      <mat-radio-button value="1">{{ 'test.ui.disabled1' | transloco }}</mat-radio-button>
      <mat-radio-button value="2">{{ 'test.ui.disabled2' | transloco }}</mat-radio-button>
    </mat-radio-group>

    <hr>

    <h3>{{ 'test.ui.select' | transloco }}</h3>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'test.ui.ciboPreferito' | transloco }}</mat-label>
      <mat-select
        name="favoriteFood"
        aria-describedby="favoriteFoodHint">
        @for (food of foods; track food) {
          <mat-option [value]="food.value">{{ food.viewValue }}</mat-option>
        }
      </mat-select>
      <mat-hint id="favoriteFoodHint">{{ 'test.ui.chooseYourFavoriteFood' | transloco }}</mat-hint>
    </mat-form-field>

    <hr>

    <h3>{{ 'test.ui.slideToggle' | transloco }}</h3>
    <!--Accessibilità già gestita da material, aggiungere aria label per toggle senza label testuale-->
    <!--TODO: Aggiungere a documentazione-->
    <p><mat-slide-toggle>{{ 'test.ui.slideMe' | transloco }}</mat-slide-toggle></p>

    <hr>

    <h3>{{ 'test.ui.table' | transloco }}</h3>
    <!--TODO: Aggiungere a documentazione-->
    <!--Come nei casi precedenti, viene gestito in autonomia tutto da material. Aggiungere solo aria-label se necessario descrivere meglio qualcosa-->

    <table mat-table [dataSource]="dataSourceTable" class="mat-elevation-z8">

        <!-- Position Column -->
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef> {{ 'test.ui.no2' | transloco }} </th>
          <td mat-cell *matCellDef="let element"> {{element.position}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> {{ 'test.ui.name' | transloco }} </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="weight">
          <th mat-header-cell *matHeaderCellDef> {{ 'test.ui.weight' | transloco }} </th>
          <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="symbol">
          <th mat-header-cell *matHeaderCellDef> {{ 'test.ui.symbol' | transloco }} </th>
          <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <hr>

    <h3>{{ 'test.ui.listPage' | transloco }}</h3>

    <ui-list-page
      [columnsInfo]="columnsInfo"
      [dataSource]="dataSource"
      [dataTransform]="dataTransform"
      [gridItemTemplate]="gridItemTemplate"
      currentSortColumn="titolo"
      currentSortDirection="asc"
    >
    </ui-list-page>

    <ng-template #gridItemTemplate let-item="itemData">
      <!-- TODO: sistemare UI card -->
      <mat-card class="card" appearance="outlined">
      <div class="card-header">
        <ui-priority-status [priority]="item.priority"></ui-priority-status>
        <div >
          <div>{{(item.dataTask | date: 'dd/MM/yyyy HH:mm' : 'UTC' ) || '-' }}</div>
          <div>{{item.primaryRole.name}}</div>
        </div>
      </div>
      <mat-card-header>
        <mat-card-title> {{item.titolo}}</mat-card-title>
        <mat-card-subtitle> {{item.nome}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p> {{item.descrizione}} </p>
        <p> {{item.notaUtente}} </p>
      </mat-card-content>
      </mat-card>
    </ng-template>

    <hr>


    <h3>{{ 'test.ui.seachbar' | transloco }}</h3>
    <p>{{ 'test.ui.todoRiposiaionareUnaSearchbar' | transloco }}</p>

    <hr>
  </div>
  <div role="region" [attr.aria-label]="'test.ui.demoForm' | transloco">
    <h2>{{ 'test.ui.demoForm' | transloco }}</h2>

    <form [formGroup]="userProfileForm" (ngSubmit)="onSubmit()">
      <h3 id="user-data">{{ 'test.ui.datiUtente' | transloco }}</h3>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'test.ui.nome' | transloco }}</mat-label>
        <input matInput id="firstName" formControlName="firstName" aria-required="true" aria-describedby="firstName-errors">
      </mat-form-field>
      @if (userProfileForm.get('firstName')?.invalid && userProfileForm.get('firstName')?.touched) {
        <div id="firstName-errors">
          @if (userProfileForm.get('firstName')?.errors?.['required']){
            <div role="alert" aria-live="assertive">
              <span style="color: red">{{ 'test.ui.nomeERichiesto' | transloco }}</span>
            </div>
          }
          @if (userProfileForm.get('firstName')?.errors?.['minlength']){
            <div role="alert" aria-live="assertive">
              <span style="color: red">{{ 'test.ui.nomeDeveAvereAlmeno3Caratteri' | transloco }}</span>
            </div>
          }
        </div>
      }

      <mat-form-field appearance="outline">
        <mat-label>{{ 'test.ui.cognome' | transloco }}</mat-label>
        <input matInput id="lastName" formControlName="lastName" aria-required="true" aria-describedby="lastName-errors">
      </mat-form-field>
      @if (userProfileForm.get('lastName')?.invalid && userProfileForm.get('lastName')?.touched) {
        <div id="lastName-errors">
          @if (userProfileForm.get('lastName')?.errors?.['required']) {
            <div role="alert" aria-live="assertive">
              <span style="color: red">{{ 'test.ui.cognomeERichiesto' | transloco }}</span>
            </div>
          }
        </div>
      }

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" id="email" formControlName="email" placeholder="esempio@gmail.com" aria-required="true" aria-describedby="email-errors">
      </mat-form-field>
      @if (userProfileForm.get('email')?.invalid && userProfileForm.get('email')?.touched) {
        <div id="email-errors">
          @if (userProfileForm.get('email')?.errors?.['required']) {
            <div role="alert" aria-live="assertive">
              <span style="color: red">{{ 'test.ui.emailERichiesta' | transloco }}</span>
            </div>
          }
          @if (userProfileForm.get('email')?.errors?.['email']) {
            <div role="alert" aria-live="assertive">
              <span style="color: red">{{ 'test.ui.formatoEmailNonValido' | transloco }}</span>
            </div>
          }
        </div>
      }

      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>{{ 'test.ui.animale' | transloco }}</mat-label>

        <input #animalinput
          type="text"
          [placeholder]="'test.ui.selezionaUnAnimale' | transloco"
          matInput
          formControlName="animal"
          [matAutocomplete]="auto"
          (input)="filter()"
          (focus)="filter()">

        <button mat-icon-button matSuffix [attr.aria-label]="'test.ui.apriSelezioneAnimale' | transloco">
          <mat-icon>pets</mat-icon>
        </button>

        <mat-autocomplete #auto="matAutocomplete" requireSelection [displayWith]="displayFn">
          @for (option of filteredAnimalOptions; track option) {
            <mat-option [value]="option" aria-label="{{option.name}}">{{option.name}}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <div formGroupName="address" aria-labelledby="address-section">
        <h3 id="address-section">{{ 'test.ui.indirizzo' | transloco }}</h3>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'test.ui.via' | transloco }}</mat-label>
          <input matInput id="street" type="text" formControlName="street" [attr.aria-label]="'test.ui.via' | transloco">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'test.ui.citta2' | transloco }}</mat-label>
          <input matInput id="city" type="text" formControlName="city" [attr.aria-label]="'test.ui.citta2' | transloco">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'test.ui.cap' | transloco }}</mat-label>
          <input matInput id="zip" type="text" formControlName="zip" aria-label="CAP">
        </mat-form-field>
      </div>

      <div formArrayName="phoneNumbers" aria-labelledby="phone-section">
        <h3 id="phone-section">{{ 'test.ui.numeriDiTelefono' | transloco }}</h3>
        @for(phoneControl of phoneNumbers.controls; let i = $index; track $index) {
          <div class="phone-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'test.ui.telefono2' | transloco: { value0: (i + 1) } }}</mat-label>
              <input
                matInput
                  type="tel"
                  inputmode="numeric"
                  maxlength="20"
                  pattern="[0-9]{0,20}"
                [formControlName]="i"
                [attr.aria-label]="(('test.ui.numeroDiTelefono' | transloco) + ' ') + (i + 1)"
              >
            </mat-form-field>
            <button
              mat-button
              color="warn"
              type="button"
              (click)="removePhoneNumber(i)"
              [attr.aria-label]="(('test.ui.rimuoviNumero' | transloco) + ' ') + (i + 1)"
            >
              {{ 'test.ui.rimuovi' | transloco }}
            </button>
          </div>
        }
        <button
          mat-raised-button
          type="button"
          (click)="addPhoneNumber()"
          [attr.aria-label]="'test.ui.aggiungiUnNuovoNumeroDiTelefono' | transloco"
        >
          {{ 'test.ui.aggiungiNumero' | transloco }}
        </button>
      </div>

      <button
        mat-raised-button
        type="button"
        (click)="toggleFormDisabled()"
        [attr.aria-label]="userProfileForm.disabled ? ('test.ui.abilitaIlModulo' | transloco) : ('test.ui.disabilitaIlModulo' | transloco)"
      >
        {{ userProfileForm.disabled ? ('test.ui.abilitaForm' | transloco) : ('test.ui.disabilitaForm' | transloco) }}
      </button>

      <div>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [attr.aria-label]="'test.ui.salvaIlProfilo' | transloco"
        >
          {{ 'test.ui.salvaProfilo' | transloco }}
        </button>
      </div>
    </form>

    <!-- Accessibilità nascosta per screen reader -->
    <div aria-live="polite" class="visually-hidden">
      {{ userProfileForm.status === 'INVALID' ? ('test.ui.ilFormContieneErrori' | transloco) : '' }}
    </div>
  </div>

  <hr>
</div>
